export default "__VITE_ASSET__BSOgSHY9__"